var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{class:_vm.badgeClass,attrs:{"title":_vm.title}},[_c('span',{staticClass:"f-badge-text"},[_vm._t("default")],2),(_vm.counter)?_c('f-time-elapsed',{staticClass:"ml-1",attrs:{"minimal":true,"time":_vm.counter}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }